export default __webpack_public_path__ + "static/media/Animals_08.d6e6b59c.png";